import React from 'react';
import { Form, Button, message, Input } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
const { TextArea } = Input;

const OilPricesForm = ({ fields, isNew, id, dataSelect, reload, onChange, setLoading }) => {
  const handleCreate = async (data) => {
    data.companyId = JSON.parse(localStorage.getItem('user_data_decode_token_tms'))?.CompanyId;

    try {
      const res = await ApiServices.createSupplierBill(data);
      if (res?.data?.data) {
        message.success('Thêm mới NCC Hoá đơn thành công');
        return reload();
      } else {
        message.error('Thêm mới NCC Hoá đơn thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới NCC Hoá đơn thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const handleUpdate = async (data) => {
    data.id = id;
    data.companyId = dataSelect.companyId;
    try {
      const res = await ApiServices.updateSupplierBill(id, data);
      if (res.data) {
        message.success('Cập nhật NCC Hoá đơn thành công');
        return reload();
      } else {
        message.error('Cập nhật NCC Hoá đơn thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật NCC Hoá đơn thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await handleCreate(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await handleUpdate(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      className='form-input-data'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        name='name'
        label='Nhà cung cấp'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập nhà cung cấp',
          },
        ]}
      >
        <TextArea rows={4} placeholder='Vui lòng nhập nhà cung cấp' />
      </Form.Item>
      <Form.Item name='address' label='Địa chỉ'>
        <TextArea rows={4} placeholder='Vui lòng nhập địa chỉ' />
      </Form.Item>
      <Form.Item name='note' label='Ghi chú'>
        <TextArea rows={4} placeholder='Vui lòng nhập ghi chú' />
      </Form.Item>
      <Form.Item {...tailLayout} className='submit-form-input-data'>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { OilPricesForm };
